export const formatTokenId = (str: string | undefined): string | null => {
  if (str && str.length > 9) {
    return `#${str.substring(0, 4)}...${str.substring(str.length - 4)}`;
  }
  if (str) {
    return `#${str}`;
  }
  return null;
};
